import { render, staticRenderFns } from "./BusinessIdentityVerification.vue?vue&type=template&id=b64c97fa&"
import script from "./BusinessIdentityVerification.vue?vue&type=script&lang=js&"
export * from "./BusinessIdentityVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports